import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { BodyWrapper, Header, MainWrapper } from '@components';
import { GlobalContext } from '@contexts';
import { ChevronRightIcon } from '@svgs';

import AccountSidebar from '../components/AccountSidebar/AccountSidebar.jsx';

import { ClearCache } from './ClearCache/ClearCache.jsx';

export const Organization = () => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  return (
    <>
      <Header />
      <BodyWrapper>
        <AccountSidebar />
        <MainWrapper>
          <div className="sb-main-breadcrumbs">
            <ul className="sb-flex">
              <li className="sb-flex">
                <span>{t('Account settings')}</span>
                <ChevronRightIcon />
              </li>
              <li className="sb-flex">
                <span>{t('Organization settings')}</span>
              </li>
            </ul>
          </div>
          <div className="sb-manage-content">
            <div className="sb-manage-content-head">
              <h1>{t('Organization settings')}</h1>
            </div>
            <div className="sb-content-view-row">
              <ClearCache />
            </div>
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
